'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	var language = {};
	(0, _forOwn2.default)(Resx.DataTables, function (v, k) {
		var key = k.replace(/_/g, '.');
		if (v !== key) {
			(0, _set3.default)(language, key, v);
		}
	});
	log('data-tables localization: %o', language);
	return language;
};

var _set2 = require('lodash/set');

var _set3 = _interopRequireDefault(_set2);

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

var _localize = require('../core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('DataTables');
var log = require('debug')('linksoft:datatables:language');

;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/language.js
// module id = 484
// module chunks = 0